import type { SidebarComponent } from '@tunasong/ui-lib'
import type { FC } from 'react'
import styles from './sidebar-activities.module.css'
import ActivityStream from '../activities/activity-stream.js'
import { graphHooks } from '@tunasong/graph-lib/react'
import { PanelEmptyState } from './panel-empty-state.js'

export const SidebarActivities: FC<SidebarComponent> = ({ entity }) => {
  const { activities, isLoading } = graphHooks.useActivities(entity.id)

  if (isLoading) {
    return null
  }

  return (
    <div className={styles.container}>
      {activities.length === 0 ? (
        <PanelEmptyState title="No activity yet" body="Edits by you and your collaborators show up here." />
      ) : (
        <ActivityStream activities={activities} />
      )}
    </div>
  )
}
